import { normalizePhoneNumber } from 'features/call/call-base/helpers';
import type { TranscriptSpeakerRole } from 'features/voice-meeting/interfaces';

interface ResolveCaptionSpeakerLabelParams {
  speakerLabel: string;
  speakerRole: TranscriptSpeakerRole;
  knownHearingName: string | null;
  primaryHearingPhoneNumber: string;
}

export const resolveCaptionSpeakerLabel = ({
  speakerLabel,
  speakerRole,
  knownHearingName,
  primaryHearingPhoneNumber,
}: ResolveCaptionSpeakerLabelParams): string => {
  const trimmedLabel = speakerLabel.trim();
  const isRemoteCallerLabel = trimmedLabel.toLowerCase() === 'caller';
  const isPrimaryHearingPhoneLabel =
    primaryHearingPhoneNumber.length > 0 &&
    normalizePhoneNumber(trimmedLabel) === primaryHearingPhoneNumber;

  if (
    speakerRole === 'remote' &&
    knownHearingName &&
    (isRemoteCallerLabel || isPrimaryHearingPhoneLabel)
  ) {
    return knownHearingName;
  }

  return trimmedLabel;
};
